<cc-ng1-user-list
  [userStats]="userStats"
  [userList]="userList"
  [state]="state"
  [userIndex]="id"
  *ngIf="userStats && userList"
></cc-ng1-user-list>

<cc-section>
  <cc-ng1-user-exists-invite
    [user]="user"
    *ngIf="user"
  ></cc-ng1-user-exists-invite>
</cc-section>
